var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-user-role"},[_c('div',{staticClass:"no-user-role-body"},[_vm._v(" "+_vm._s(_vm.$companyConfiguration.i18n.t('common', 'user_no_role_overlay_text', 'Отсутствуют права доступа'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }